<template lang="html">
    <div class="container">
        <div class="row">
            <div class="col s12">
                <img class="center responsive-img" src="@/assets/images/hmy_claim.png"/>
            </div>
        </div>

        <div class="row">
            <div class="col s12 m10 center">
                <router-link class="card horizontal" :to="{ name: 'Improvement' }">
                    <div class="card-image">
                        <img src="@/assets/images/bulb.png">
                    </div>
                    <div class="card-stacked">
                        <div class="card-content">
                            <p class="idea">J'ai une idée ! </p>
                            <p class="grey-text">Partagez-nous vos idées d'améliorations et remarques. Nous en tenons compte !</p>

                        </div>
                        <div class="btn-floating btn-large halfway-fab waves-effect waves-light light-blue"><i class="material-icons">add</i></div>
                    </div>
                </router-link>
            </div>
        </div>


        <div class="row">
            <a href="" class="col s6 m6">
                <div class="card grey darken-1">
                    <div class="card-image">
                        <img src="@/assets/images/meeting.png">
                    </div>
                    <div class="card-action">
                        <p class="small-card-text">Tutos vidéo</p>
                        <span class="small-card-title">Prochainement</span>
                    </div>
                </div>
            </a>
            <a href="#" class="col s6 m6">
                <div class="card grey darken-1">
                    <div class="card-image">
                        <img src="@/assets/images/chat.png">
                    </div>
                    <div class="card-action">
                        <p class="small-card-text">Live Chat</p>
                        <span class="small-card-title">Prochainement</span>
                    </div>
                </div>
            </a>
        </div>
        <div class="row">
            <div class="col 12"><a href="mailto:amelioration.montage@hmy-group.com" class="center waves-effect waves-light btn-large light-blue"><i class="material-icons left">mail_outline</i>CONTACT AMELIORATION CONTINUE</a></div>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase'

    export default {
        name: 'Home',
        data(){
            return{

            }
        },
        mounted(){
            // console.log(firebase.auth().currentUser)

        }
    }
</script>

<style lang="css" scoped>
.card .card-content p{
    margin-bottom: 15px;
}
.idea{
    font-weight: 600;
    font-size: 1.5em;
    color: grey;
}
.small-card-text{
    font-weight: 700;
    font-size: 1.1em;
    color: white;
}
.small-card-title{
    font-size: 1em;
    color: white;
}
.card{
    border-bottom-right-radius: 3%;
    border-bottom-left-radius:  3%;
}

</style>
